import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import * as fromProjector from './+state/projectors.reducer'
import { ProjectorsEffects } from './+state/projectors.effects'
import { ProjectorsFacade } from './+state/projectors.facade'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromProjector.PROJECTORS_FEATURE_KEY, fromProjector.projectorsReducer),
    EffectsModule.forFeature([ProjectorsEffects]),
  ],
  providers: [ProjectorsFacade],
})
export class GbDashboardProjectorDataAccessModule {}
